import "./includes/Bootstrap";
import ReactDOM from "react-dom";
import React from "react";

import App from "./components/App";

const MOUNT_NODE = document.getElementById("root");

// ========================================================
// Render
// ========================================================
const render = <P extends object>(
    RootComponent: React.FunctionComponent<P> | React.ComponentClass<P>,
    hydrate: boolean,
    props: P,
): void => {
    if (!hydrate) {
        ReactDOM.render(React.createElement(RootComponent, props), MOUNT_NODE);
        return;
    }

    ReactDOM.hydrate(React.createElement(RootComponent, props), MOUNT_NODE);
};

// ========================================================
// This code is excluded from production bundle
// ========================================================
if (__HOT_RELOADING__) {
    if (module.hot) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { setConfig } = require("react-hot-loader");
        setConfig({ logLevel: "debug" });

        // Without this, private modules reload doesn't work..
        module.hot.accept();
        const moduleId: string = require.resolve("@swiggy-private/payment-client");

        // Setup hot module replacement
        module.hot.accept(["./components/App", moduleId], () =>
            setImmediate(() => {
                MOUNT_NODE && ReactDOM.unmountComponentAtNode(MOUNT_NODE);
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                render(require("./components/App").default, false, {
                    apiHost: window.__API_HOST__,
                    paymentHost: window.__PAYMENT_HOST__,
                    analyticsHost: window.__ANALYTICS_HOST__,
                    headers: window.__headers__,
                    path: `${location.pathname}${location.search}`,
                });
            }),
        );
    }
}

render(App, true, {
    apiHost: window.__API_HOST__,
    paymentHost: window.__PAYMENT_HOST__,
    analyticsHost: window.__ANALYTICS_HOST__,
    simplPostLinkingRedirectUrl: window.__SIMPL_REDIRECT_URL__,
    headers: window.__headers__,
    path: `${location.pathname}${location.search}`,
});
